<template>
  <div>
    <PoppinsCheckbox
      v-model="serviceSelected"
      :checkboxId="checkboxId"
      :name="checkboxId"
      :labelName="serviceRate.checkboxLabel"
      :aria-label="generateScreenReaderLabel(serviceRate.checkboxLabel)"
      @update:model-value="resetRate()"
    />
    <PoppinsTextField
      v-if="serviceSelected"
      :id="textFieldId"
      :modelValue="rate"
      :name="textFieldId"
      class="pb-24"
      :labelName="serviceRate.inputLabel"
      :aria-label="'Set your minimum rate'"
      type="text"
      pattern="[0-9]*"
      inputmode="numeric"
      :required="true"
      :status="formStatuses.rate"
      :helperText="helperText"
      :limit-input-to-pattern="true"
      @update:model-value="onInput"
      @blur="validate"
    />
  </div>
</template>

<script lang="ts">
import HelperStatus from '@/helpers/status';
import Checkbox from '@/components/checkbox/Checkbox.vue';
import TextField from '@/components/textfield/TextField.vue';

export default {
  name: 'ServiceRatesInput',
  components: {
    PoppinsTextField: TextField,
    PoppinsCheckbox: Checkbox,
  },
  props: {
    serviceRate: {
      type: Object,
      required: true,
    },
  },
  data(): {
    formStatuses: {
      rate: HelperStatus;
    };
  } {
    return {
      formStatuses: {
        rate: HelperStatus.Neutral,
      },
    };
  },
  computed: {
    serviceSelected: {
      get(): boolean {
        return this.serviceRate.selected;
      },
      set(newValue: boolean) {
        this.$emit('serviceSelected', {
          service: this.serviceRate.service as string,
          selected: newValue,
        });
      },
    },
    rate(): string {
      return this.serviceRate.rate;
    },
    checkboxId(): string {
      return `${this.serviceRate.service}-selected`;
    },
    textFieldId(): string {
      return `${this.serviceRate.service}-rate`;
    },
    helperText(): string {
      return this.formStatuses.rate ? '' : this.serviceRate.helperText;
    },
  },
  methods: {
    onInput(dollarValue: string | Event) {
      this.resetErrorState('rate');
      const normalizedValue =
        typeof dollarValue === 'string' ? dollarValue : ((dollarValue?.target as HTMLInputElement | null)?.value ?? '');
      const serviceAndRate = {
        service: this.serviceRate.service as string,
        rate: normalizedValue,
      };

      this.$emit('update:modelValue', serviceAndRate);
    },
    validate() {
      if ((this.serviceSelected && !this.serviceRate.rate) || this.serviceRate.rate === '0') {
        this.triggerErrorState('rate');
      }
      return this.formStatuses.rate;
    },
    triggerErrorState(fieldName) {
      this.formStatuses[fieldName] = HelperStatus.Error;
    },
    resetErrorState(fieldName) {
      this.formStatuses[fieldName] = HelperStatus.Neutral;
    },
    resetRate() {
      this.onInput('');
    },
    generateScreenReaderLabel(label) {
      return `I offer ${label}`;
    },
  },
};
</script>
